import type { FC, PropsWithChildren } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { AccordionItem as CoreAccordionItem } from "@jti/core-components/components/Accordion";

import { getBuilderChildrenCount } from "@/libs/builder/utils/getBuilderChildrenCount";

import { Placeholder } from "../Placeholder/Placeholder";

import type { accordionItemInputs } from "./AccordionItem.builder";

export type AccordionBuilderProps = BuilderComponentProps<typeof accordionItemInputs>;

export const AccordionItem: FC<PropsWithChildren<AccordionBuilderProps>> = ({ children, title, id }) => {
  return (
    <CoreAccordionItem id={`${id}${title}`} title={title}>
      {isEditing() && getBuilderChildrenCount(children) === 0 && <Placeholder>Add content here</Placeholder>}
      {children}
    </CoreAccordionItem>
  );
};
